import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { FaChartLine, FaEye, FaGem, FaShieldAlt } from "react-icons/fa";
import { BRAND } from "../config/brand";

const whyItems = [
  {
    icon: FaGem,
    title: "Real-asset narrative",
    description:
      "A premium token story shaped around AI powered value, scarcity, and long term reserve confidence.",
  },
  {
    icon: FaEye,
    title: "Visible token data",
    description:
      "Supply, chain, contract, purchase assets, and token details are placed clearly so buyers do not have to search.",
  },
  {
    icon: FaShieldAlt,
    title: "Trust-first presale flow",
    description:
      "Wallet connection, stable purchase options, and add-to-wallet actions keep the buyer journey direct and familiar.",
  },
  {
    icon: FaChartLine,
    title: "Market-readiness path",
    description:
      "The page leads from asset conviction to tokenomics, purchase flow, liquidity, roadmap, and community growth.",
  },
];

function About() {
  const aboutHeadRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.5 }
    );

    const aboutHead = aboutHeadRef.current;

    if (aboutHead) {
      observer.observe(aboutHead);
    }

    return () => {
      if (aboutHead) {
        observer.unobserve(aboutHead);
      }
    };
  }, []);

  return (
    <div className="about-main">
      <div
        className={`about-head ${isVisible ? "visible" : ""}`}
        ref={aboutHeadRef}
      >
        <span>WHY {BRAND.tokenSymbol}</span>
        <h1>
          Moonlit Security, Real Asset <br /> Conviction
        </h1>
      </div>

      <div className="about-cards about-value-grid">
        {isVisible && (
          whyItems.map(({ icon: Icon, title, description }, index) => (
            <motion.article
              className="about-value-card"
              key={title}
              initial={{ y: 42, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                duration: 0.75,
                delay: index * 0.12,
                ease: "easeOut",
              }}
            >
              <Icon />
              <small>0{index + 1}</small>
              <h2>{title}</h2>
              <p>{description}</p>
            </motion.article>
          ))
        )}
      </div>
    </div>
  );
}

export default About;
